<template>
  <simplebar id="sidebar-container" class="simplebar-fix">
    <b-img
      :src="logoImg"
      :state="Boolean(logoImg)"
      class="mr-auto mb-2"
      :style="{ 'max-height': '5rem', 'object-fit': 'contain' }"
    />
    <div class="sidebar-top-container">
      <TTReader :panel="SIDEBAR_TOP" :data-cy="SIDEBAR_TOP" />
    </div>
    <SidebarWidgets v-if="showSidebarWidgets" data-test="sidebar-widgets" />
    <div class="sidebar-bottom-container">
      <TTReader :panel="SIDEBAR_BOT" :data-cy="SIDEBAR_BOT" />
    </div>
    <SideBarFade />
  </simplebar>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import TTReader from '@/components/TipTap/wrappers/TTReader.vue'
import SidebarWidgets from '@/components/public/SidebarWidgets.vue'
import SideBarFade from '@/components/public/SideBarFade.vue'

// @ts-ignore simplebar-vue import
import simplebar from 'simplebar-vue'
import 'simplebar/dist/simplebar.min.css'

import { StoryKeys } from '@/types'
import { APP_CONFIG_KEY } from '@/constants'

const components = {
  simplebar,
  TTReader,
  SidebarWidgets,
  SideBarFade,
}

@Component({ components })
export default class SideBar extends Vue {
  SIDEBAR_TOP = StoryKeys.SIDEBAR_TOP
  SIDEBAR_BOT = StoryKeys.SIDEBAR_BOT

  get logoImg() {
    return this.$typedStore.activeVisualisation.visualisationStore.entities.images.imageOrPreview([
      'config',
      APP_CONFIG_KEY,
      'logo',
    ])
  }

  get showSidebarWidgets() {
    return this.$typedStore.activeVisualisation.displaysTreeData
  }
}
</script>

<style lang="scss" scoped>
#sidebar-container {
  height: 100%;
  width: 100%;
  padding: min(10%, 10em);
  @media (max-width: 1100px) {
    padding: 5%;
  }
  @media (max-width: 900px) {
    padding: 0;
  }
}

.sidebar-bottom-container {
  min-height: 100px;
}
</style>
